import script from "./LeftMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./LeftMenu.vue?vue&type=script&setup=true&lang=js"

import "./LeftMenu.vue?vue&type=style&index=0&id=463333b0&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-463333b0"]])

export default __exports__